<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="회원승인 관리" device="web" :IsUseInfo="true">
        <template v-slot:Info>*처리(승인/거절) 완료된 요청은 일주일 후 자동 삭제 됩니다.</template>
        <template v-slot:body>
          <DxDataGrid
            id="memberApprovalDataGrid"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="gridMain"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            key-expr="id"
            @editing-start="onEditingStart"
            @editor-preparing="onEditorPreparing"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxColumn data-field="compId" data-type="string" :visible="false" />

            <DxColumn data-field="clntId" data-type="string" :visible="false" />

            <DxColumn data-field="userCd" data-type="string" width="200px" alignment="center" caption="아이디" :allow-editing="false" />

            <DxColumn data-field="userPs" data-type="string" width="150px" alignment="left" :visible="false" />

            <DxColumn data-field="userNm" data-type="string" width="100px" alignment="center" caption="이름" :allow-editing="false" />

            <DxColumn
              data-field="hireGubn"
              data-type="string"
              width="120px"
              alignment="center"
              caption="고용구분"
              css-class="devest-grid-header-require"
            >
              <DxLookup :data-source="hireGubnList" value-expr="minorCd" display-expr="minorNm" />
            </DxColumn>

            <DxColumn
              data-field="groupAuth"
              data-type="string"
              width="180px"
              alignment="center"
              caption="권한그룹"
              css-class="devest-grid-header-require"
            >
              <DxLookup :data-source="groupAuthDataSource" value-expr="grpAuthCd" display-expr="grpAuthNm" />
            </DxColumn>

            <DxColumn
              data-field="connDtS"
              data-type="string"
              width="150px"
              alignment="center"
              caption="접속허용 시작일"
              css-class="devest-grid-header-require"
              edit-cell-template="dateEditor"
            />

            <DxColumn
              data-field="connDtE"
              data-type="string"
              width="150px"
              alignment="center"
              caption="접속허용 종료일"
              edit-cell-template="dateEditor"
              css-class="devest-grid-header-require"
            />
            <template #dateEditor="{ data: cellInfo }">
              <div>
                <DxDateBox
                  :value="cellInfo.value"
                  type="date"
                  picker-type="calendar"
                  display-format="yyyy.MM.dd"
                  :use-mask-behavior="true"
                  @value-changed="onDateValueChanged($event, cellInfo)"
                />
              </div>
            </template>

            <DxColumn
              data-field="approvalStatus"
              data-type="string"
              width="240px"
              alignment="center"
              caption="승인"
              cell-template="approvalStatusTemplate"
              :calculate-display-value="(e) => displayApproval(e)"
              :allow-editing="false"
            ></DxColumn>
            <template #approvalStatusTemplate="{ data: cellInfo }">
              <div v-if="cellInfo.data.approvalStatus == 'N'">
                <v-btn outlined elevation="0" small class="mr-1 grid-btn" color="error" @click="btnRefuse(cellInfo)">거절</v-btn>
                <v-btn @click="btnApprove(cellInfo)" outlined elevation="0" color="primary" small class="ml-1 grid-btn">승인</v-btn>
              </div>
              <div v-else-if="cellInfo.data.approvalStatus == 'A'">{{ cellInfo.displayValue }}</div>
              <div style="color: red" v-else-if="cellInfo.data.approvalStatus == 'R'">{{ cellInfo.displayValue }}</div>
            </template>

            <DxColumn
              data-field="companyGroup"
              caption="사업장 그룹"
              width="200px"
              data-type="string"
              alignment="center"
              :allow-editing="false"
              cell-template="companyGroupReadOnly"
            />
            <template #companyGroupReadOnly="{ data: cellInfo }">
              <v-autocomplete
                class
                item-text="compNm"
                item-value="compId"
                :menu-props="{ offsetY: true }"
                :items="companyGroupList"
                chips
                multiple
                dense
                append-icon
                :value="cellInfo.value != undefined ? cellInfo.value.split(',') : ''"
              />
            </template>

            <DxColumn data-field="hpNo" data-type="string" width="150px" alignment="center" caption="휴대폰번호" />
            <DxColumn
              data-field="reqDt"
              data-type="string"
              width="150px"
              alignment="center"
              caption="요청일시"
              :allow-editing="false"
              :min-width="180"
            />
            <DxColumn data-field="remark" data-type="string" alignment="left" caption="비고" :min-width="180" />
          </DxDataGrid>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00004'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnDelete="btnDelete()"></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

import { DxLookup } from 'devextreme-vue/data-grid'

import DxDateBox from 'devextreme-vue/date-box'

import { getCompanyGroup } from '@/api/baseManage/esgHRManage'
import { getMemberApproval, saveMemberApproval, saveApprovalRefuse, deleteMemberApproval } from '@/api/baseManage/memberApprovalManage'

import { getCommonCode } from '@/api/common/commonApi'
import { getGroupData } from '@/api/setting/groupManage'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'memberApprovalDataGrid',
  components: {
    DxLookup,
    DxDateBox,
    // 절차서 컴포넌트
    ProcedureComponent,
  },
  data() {
    return {
      dxDataGridRef: 'memberApprovalDataGrid',
      buttonUseList: [
        'btnSearch', //조회
        // 'btnSave', //저장
        'btnDelete', //삭제
      ],
      authCd: this.getAuthCd(),
      gridMain: [],
      hireGubnList: [],
      groupAuthList: [],
      groupAuthDataSource: [],
      companyGroupList: [],
      phonePattern: /^\d{3}-(\d{4}||\d{3})-\d{4}$/i,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
    }
  },
  computed: {},
  beforeMount() {},
  activated() {
    this.btnSearch()
    this.setComboBoxData()
  },
  mounted() {
    // 켜질때 조회
    this.btnSearch(true)
  },
  methods: {
    btnSearch(isNotify) {
      this.openLoading('searching')
      let param = {
        clntId: this.getClntId(),
      }

      this.companys = []
      getMemberApproval(param, isNotify)
        .then((res) => {
          if (res.success) {
            // console.log('memeberApprovalList : ', res.list)
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.gridMain = []
            this.gridMain = res.list
            // 승인요청시 default는 근로자임
            this.gridMain.forEach((element) => {
              if (element.approvalStatus == 'N') {
                element.groupAuth = 'normal'
              }
            })
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.endLoading()
        })
    },
    // async btnSave() {
    //   this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
    //     .then(selectedRows => {
    //       if (selectedRows.length === 0) {
    //         this.vToastify(this.$t('selectionData'), 'warn')
    //         return
    //       }
    //       this.vToastifyPrompt(
    //         this.$t('doSaveData'),
    //         'info',
    //         current => {
    //           let source = this.GetDataGrid(this.dxDataGridRef).getDataSource()
    //           let items = source.items()
    //           this.GetDataGrid(this.dxDataGridRef).beginUpdate()
    //           this.GetDataGrid(this.dxDataGridRef).saveEditData()

    //           //필수입력값 체크
    //           var pattern = /\s/g
    //           var index = selectedRows.findIndex(
    //             element =>
    //               element.tempUserId == null ||
    //               element.userNm == null ||
    //               element.hireGubn == null ||
    //               element.reqDt == null ||
    //               element.connDtS == null ||
    //               element.connDtE == null ||
    //               element.approvalStatus == null ||
    //               element.groupAuth == null ||
    //               element.tempUserId == '' ||
    //               element.userNm == '' ||
    //               element.hireGubn == '' ||
    //               element.reqDt == '' ||
    //               element.connDtS == '' ||
    //               element.connDtE == '' ||
    //               element.approvalStatus == '' ||
    //               element.groupAuth == ''
    //           )

    //           if (index >= 0) {
    //             this.vToastify(this.$t('필수항목 입력해주세요.<br>[아이디, 이름, 고용구분, 요청일시, 접속허용 시작일시, 접속허용 종료일시, 승인, 권한그룹]'), 'warn')
    //             this.GetDataGrid(this.dxDataGridRef).endUpdate()
    //             return
    //           }

    //           //유효성 검사
    //           var valid = ''
    //           var patternIndex = selectedRows.findIndex(element => {
    //             if (element.hpNo.match(this.phonePattern) == null) {
    //               valid = 'hpNo'
    //               return true
    //             }
    //           })

    //           if (patternIndex >= 0) {
    //             this.vToastify(
    //               valid == 'hpNo'
    //                 ? this.$t('올바르지 않은 전화번호 형식입니다.')
    //                 : this.$t(''),
    //               'warn'
    //             )
    //             this.GetDataGrid(this.dxDataGridRef).endUpdate()
    //             return
    //           }

    //           //저장 api
    //           this.openLoading('saving')
    //           saveMemberApproval(selectedRows, true)
    //             .then(res => {
    //               if (res.success) {
    //                 this.btnSearch(false)
    //               }
    //             })
    //             .catch(error => {})
    //             .finally(() => {
    //               this.GetDataGrid(this.dxDataGridRef).endUpdate()
    //               this.endLoading()
    //             })
    //         },
    //         null,
    //         true
    //       )
    //     })
    // },
    btnRefuse(cellInfo) {
      console.log('btnRefuse', cellInfo)
      // this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      //   .then(selectedRows => {
      //     if (selectedRows.length === 0) {
      //       this.vToastify(this.$t('selectionData'), 'warn')
      //       return
      //     }
      //     this.vToastifyPrompt(
      //       this.$t(`[${cellInfo.data.tempUserId}] 승인거절 하시겠습니까?`),
      //       'info',
      //       current => {
      //         let source = this.GetDataGrid(this.dxDataGridRef).getDataSource()
      //         let items = source.items()
      //         this.GetDataGrid(this.dxDataGridRef).beginUpdate()
      //         this.GetDataGrid(this.dxDataGridRef).saveEditData()

      //         selectedRows.forEach(element => {
      //           element.approvalStatus = 'R'
      //         })
      //         //저장 api
      //         this.openLoading('saving')
      //         saveApprovalRefuse(selectedRows, true)
      //           .then(res => {
      //             if (res.success) {
      //               this.btnSearch(false)
      //             }
      //           })
      //           .catch(error => {})
      //           .finally(() => {
      //             this.GetDataGrid(this.dxDataGridRef).endUpdate()
      //             this.endLoading()
      //           })
      //       },
      //       null,
      //       true
      //     )
      //   })

      this.vToastifyPrompt(
        this.$t(`[${cellInfo.data.userCd}:${cellInfo.data.userNm}] 승인거절 하시겠습니까?`),
        'info',
        (current) => {
          this.vToastifyPrompt(
            this.$t(`승인거절 후 해당 데이터를 삭제 하시겠습니까?`),
            'info',
            async () => {
              let source = this.GetDataGrid(this.dxDataGridRef).getDataSource()
              let items = source.items()
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              cellInfo.data.approvalStatus = 'R'
              //저장 api
              let saveData = []
              cellInfo.data.deleteFlag = true
              saveData.push(cellInfo.data)
              this.openLoading('saving')
              saveApprovalRefuse(saveData, true)
                .then((res) => {
                  if (res.success) {
                    this.btnSearch(false)
                  }
                })
                .catch((error) => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.endLoading()
                })
            },
            async () => {
              let source = this.GetDataGrid(this.dxDataGridRef).getDataSource()
              let items = source.items()
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              cellInfo.data.approvalStatus = 'R'
              //저장 api
              let saveData = []
              cellInfo.data.deleteFlag = false
              saveData.push(cellInfo.data)
              this.openLoading('saving')
              saveApprovalRefuse(saveData, true)
                .then((res) => {
                  if (res.success) {
                    this.btnSearch(false)
                  }
                })
                .catch((error) => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.endLoading()
                })
            },
            true
          )
        },
        null,
        true
      )
    },
    btnApprove(cellInfo) {
      console.log('@@ cellInfo', cellInfo)
      // [console.log('승인uuid', cellInfo)]
      this.vToastifyPrompt(
        this.$t(`[${cellInfo.data.userCd}:${cellInfo.data.userNm}] 승인 하시겠습니까?`),
        'info',
        (current) => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()

          let data = this.gridMain.find((element) => element.id == cellInfo.key)

          if (
            data.hireGubn == null ||
            data.connDtS == null ||
            data.connDtE == null ||
            data.groupAuth == null ||
            data.hireGubn == '' ||
            data.connDtS == '' ||
            data.connDtE == '' ||
            data.groupAuth == ''
          ) {
            this.vToastify(this.$t('필수항목 입력해주세요.<br>[고용구분, 접속허용 시작일, 접속허용 종료일, 권한그룹]'), 'warn')
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            return
          }

          //유효성 검사
          if (cellInfo.data.hpNo && cellInfo.data.hpNo.match(this.phonePattern) == null) {
            this.vToastify(this.$t('올바르지 않은 전화번호 형식입니다.'), 'info')
            this.GetDataGrid(this.dxDataGridRef).endUpdate()
            return
          }
          data.approvalStatus = 'A'
          let saveData = []
          saveData.push(data)
          //저장 api
          console.log('@@ saveData', saveData)
          this.openLoading('saving')
          saveMemberApproval(saveData, true)
            .then((res) => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .catch((error) => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    btnDelete() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then((selectedRows) => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'info')
            return
          }
          this.vToastifyPrompt(
            this.$t('승인요청을 삭제하시겠습니까?'),
            'info',
            (current) => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              this.openLoading('deleting')
              //삭제 api
              deleteMemberApproval(selectedRows, true)
                .then((res) => {
                  if (res.success) {
                    this.deleteCallBack(selectedRows)
                    this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  }
                })
                .catch((error) => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },

    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onEditingStart(e) {
      if (
        (e.data.approvalStatus == 'R' || e.data.approvalStatus == 'A') &&
        (e.column.dataField == 'connDtS' ||
          e.column.dataField == 'connDtE' ||
          e.column.dataField == 'groupAuth' ||
          e.column.dataField == 'hpNo' ||
          e.column.dataField == 'hireGubn')
      ) {
        e.cancel = true
        return
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(param) {
      var index = null
      param.forEach((key) => {
        index = this.gridMain.findIndex((obj) => obj == key)
        this.gridMain.splice(index, 1)
      })
    },
    setComboBoxData() {
      this.openLoading()
      const params = { clntId: this.getClntId(), myClntOnly: true }
      Promise.all([
        getCommonCode('CM013'), //고용구분
        getGroupData(), //권한그룹
        getCompanyGroup(params), //사업장 그룹
      ])
        .then((response) => {
          if (response.length) {
            this.hireGubnList = response[0].list.slice()
            this.groupAuthList = response[1].list.slice()
            this.companyGroupList = response[2].list.slice()
            this.groupAuthDataSource = this.groupAuthList.filter((element) => element.clientYn === 'Y')
            /*
            this.groupAuthList.forEach(el => {
              //로그인 계정 권한에 따른 권한그룹 리스트 필터
              if (this.authCd === 'master') {
                this.groupAuthDataSource = this.groupAuthList.filter(element => element.systemYn === 'Y')
              } else if (this.authCd === 'client_admin') {
                this.groupAuthDataSource = this.groupAuthList.filter(element => element.clientYn === 'Y')
              } else {
                this.groupAuthDataSource = this.groupAuthList.filter(element => element.clientYn === 'Y')
              }
            })
            */
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    displayApproval(element) {
      if (element.approvalStatus == 'A') {
        return `승인 (${element.updatedAt})`
      } else if (element.approvalStatus == 'R') {
        return `승인거절 (${element.updatedAt})`
      } else {
        return
      }
    },
    onDateValueChanged(event, cellInfo) {
      //날짜 세팅
      const date = new Date(event.value)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const dateFormat = `${year}.${month}.${day}`

      //그리드 삽입
      const cell = this.gridMain[cellInfo.rowIndex]
      cell[cellInfo.column.dataField] = dateFormat
      cellInfo.setValue(dateFormat)
      this.$refs[this.dxDataGridRef].instance.selectRows(cellInfo.row.key, true)
    },
  },
}
</script>

<style scoped></style>
